// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import BasketItemModel from '../../model/basket-item-model';
import BasketItemDTO from '../dto/basket-item-dto';
import dtoSchema from '../schemas/basket-item-schema';
import ArticleModel from '../../model/article-model';

export default abstract class BasketItemModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<BasketItemDTO>) {
    super();
    if (data) {
      this.count = data.count;
      this.article = data.article ? ArticleModel.toModel(data.article) : undefined;
    }
  }
  /**
  * @type {int32}
  */
  count?: number;
  /**
  */
  article?: ArticleModel;

  static toModel(dto: DeepPartial<BasketItemDTO>): BasketItemModel;
  static toModel(dto: DeepPartial<BasketItemDTO> | undefined | null): BasketItemModel | undefined;
  static toModel(dto: DeepPartial<BasketItemDTO> | undefined | null): BasketItemModel | undefined {
    return dto ? new BasketItemModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<BasketItemModel> | BasketItemModel): BasketItemDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      count: unwrapped.count,
      article: unwrapped.article,
    } as BasketItemDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for BasketItemModel, can not map to BasketItemDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
